/* Common Imports */

import { makeStyles } from "@material-ui/core/styles";
import React from "react";

/* Component Imports */

import mapboxgl from "!mapbox-gl";
import { Fab, SvgIcon, Typography } from "@material-ui/core";

/* Icon Imports */

import Heavie from "../../../public/images/icons/logo/favicon.svg";

/* Data Imports */

import AppConfig from "../../../AppConfig";
import VicinityTab from "./VicinityTab";

/* Configure Mapbox */

mapboxgl.accessToken = process.env.MAPBOX_PUBLIC_ACCESS_TOKEN;

const useStyles = makeStyles((theme) => ({
  mainContainer: {
    width: "100%",
    padding: "5rem 8rem 2.5rem 8rem",
    [theme.breakpoints.down("sm")]: {
      padding: "2rem 2rem 0rem 2rem",
    },
    [theme.breakpoints.down("xs")]: {
      padding: "0rem 1.5rem 0rem 1.5rem",
    },
    [theme.breakpoints.down("md")]: {
      padding: "0rem 2rem 0rem 2rem",
    },
  },
  megaContainer: {
    /* XXS breakpoint */
    [theme.breakpoints.down(theme.breakpoints.values.xs + 280)]: {
      padding: "0rem 0.5rem 1rem 0.5rem",
    },
    [theme.breakpoints.only("xs")]: {
      padding: "0rem 1.5rem 1rem 1.5rem",
    },
    [theme.breakpoints.only("sm")]: {
      padding: "0rem 3rem 1rem 3rem",
    },
    [theme.breakpoints.only("md")]: {
      padding: "0rem 4rem 1rem 4rem",
    },
    [theme.breakpoints.only("lg")]: {
      padding: "0rem 4rem 1rem 4rem",
    },
    /* XLG breakpoint */
    [theme.breakpoints.up(theme.breakpoints.values.lg + 48)]: {
      padding: "0rem 5rem 1rem 5rem",
    },
    /* Full HD breakpoint */
    [theme.breakpoints.up("xl")]: {
      padding: "0rem 23rem 1rem 23rem",
    },
    /* XXL breakpoint */
    [theme.breakpoints.up(theme.breakpoints.values.xl + 640)]: {
      padding: "0rem 36rem 1rem 36rem",
    },
    /* XXXL breakpoint */
    [theme.breakpoints.up(theme.breakpoints.values.xl + 1920)]: {
      padding: "0rem 72rem 1rem 72rem",
    },
    // margin: '0rem 0rem 6rem 0rem',
    [theme.breakpoints.down("xs")]: {
      margin: "0rem 0rem 3rem 0rem",
    },
  },
  sectionContainer: {
    display: "flex",
    flexDirection: "row",

    // [theme.breakpoints.down(theme.breakpoints.values.lg + 87)]: {
    //   gap: "10rem",
    //   width: "100%",
    // },
    [theme.breakpoints.down("lg")]: {
      // gap: "10rem",
      width: "100%",
    },
    [theme.breakpoints.down("md")]: {
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: "3rem",
      width: "100%",
    },
    // [theme.breakpoints.down(theme.breakpoints.values.sm + 330)]: {
    //   flexDirection: 'column',
    //   justifyContent: 'center',
    //   alignItems: 'center',
    //   gap: '3rem',
    //   width: '100%',
    // },
    [theme.breakpoints.down("sm")]: {
      gap: "3rem",
      width: "100%",
    },
    [theme.breakpoints.down("xs")]: {
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "flex-start",
      gap: "0.5rem",
      width: "100%",
      margin: "2rem 0rem 0rem 0rem",
    },
    justifyContent: "flex-start",
    alignItems: "flex-start",
    width: "100%",
    gap: "10rem",
  },
  text: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "flex-start",

    // width: '60%',
    [theme.breakpoints.down(theme.breakpoints.values.sm + 230)]: {
      // gap: "3rem",
      width: "100%",
    },
    [theme.breakpoints.down("xs")]: {
      width: "100%",
      // margin: "2.5rem 0rem 0rem 0rem",
    },
  },
  subHeading: {
    width: "100%",
    background: "-webkit-linear-gradient(180deg, #74378E 0%, #502761 100%)",
    "-webkit-background-clip": "text",
    "-webkit-text-fillColor": "transparent",
    margin: "0rem 0rem 1rem 0rem",
    fontWeight: 600,
    fontSize: "2.125rem",
    lineHeight: "2.563rem",
    [theme.breakpoints.down("sm")]: {
      fontSize: "1.25rem",
      lineHeight: "2rem",
      margin: "0rem 0rem 0rem 0rem",
    },
    background: "-webkit-linear-gradient(180deg, #74378E 0%, #502761 100%)",
    "-webkit-background-clip": "text",
    "-webkit-text-fillColor": "transparent",
  },
  bodyText: {
    margin: "0.5rem 0rem 0.5rem 0rem",
    width: "100%",
    fontWeight: 400,
    fontSize: "1rem",
    lineHeight: "1.5rem",
    color: "#000000",
    [theme.breakpoints.down("sm")]: {
      fontSize: "0.875rem",
      lineHeight: "1.25rem",
      color: "#666666",
    },
  },
  illustrationSizer: {
    // display: "flex,",
    // flexDirection: "column",
    // justifyContent: "center",
    // alignItems: "center",
    height: "full",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      height: "400px",
      margin: "0rem 0rem 2.5rem 0rem",
    },
    [theme.breakpoints.up("sm")]: {
      width: "100%",
      height: "400px",
    },
    [theme.breakpoints.up("md")]: {
      width: "100%",
      height: "400px",
    },
    [theme.breakpoints.up("lg")]: {
      width: "440px",
      height: "600px",
    },
    [theme.breakpoints.up("xl")]: {
      width: "500px",
      height: "600px",
    },
    position: "relative",
  },
  viv: {
    width: "100%",
    margin: "0.5rem 0rem 0.5rem 0rem",
    padding: "0rem 0rem 0rem 0rem",
  },
  mapBox: {
    display: "flex,",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    zIndex: "2",
    height: "100%",

    [theme.breakpoints.up("sm")]: {
      width: "100%",
      height: "400px",
    },
    [theme.breakpoints.up("md")]: {
      width: "100%",
      height: "400px",
    },
    [theme.breakpoints.up("lg")]: {
      width: "300px",
      height: "700px",
    },
    [theme.breakpoints.up("xl")]: {
      width: "400px",
      // height: "100%",
    },
  },
  resetMapButton: {
    // background: "linear-gradient(180deg, #74378E 0%, #502761 100%)",
    background: "#FFFFFF",
    zIndex: 2,
    position: "absolute",
    top: "1rem",
    right: "1rem",
  },
}));

const LocationSub = () => {
  const classes = useStyles();

  /* State to control flight speed */

  const [flightSpeed, setFlightSpeed] = React.useState(1);

  /* Setup default views */

  const heavieMapView = {
    center: [77.68106, 12.91049],
    zoom: 15,
    bearing: 0,
    essential: true,
    speed: flightSpeed,
    pitch: 45,
    bearing: 0,
  };
  const schoolMapView = {
    center: [77.7013, 12.9109],
    zoom: 12,
    bearing: 0,
    essential: true,
    speed: flightSpeed,
    pitch: 45,
    bearing: 0,
  };
  const mallMapView = {
    center: [77.6738, 12.9217],
    zoom: 14.5,
    bearing: 0,
    essential: true,
    speed: flightSpeed,
    pitch: 45,
    bearing: 0,
  };
  const hospitalMapView = {
    center: [77.6623, 12.9455],
    zoom: 12,
    bearing: 0,
    essential: true,
    speed: flightSpeed,
    pitch: 45,
    bearing: 0,
  };
  const otherMapView = {
    center: [77.6942, 12.9138],
    zoom: 12.5,
    bearing: 0,
    essential: true,
    speed: flightSpeed,
    pitch: 45,
    bearing: 0,
  };

  /* Setup layer iterator */

  const layerIterator = ["heavie-layer", "schools-layer", "malls-layer", "hospitals-layer", "others-layer"];

  /* State to check if map is loaded */

  const [mapLoaded, setMapLoaded] = React.useState(false);

  /* Initialize Mapbox states and references */

  const mapContainer = React.useRef(null);
  const map = React.useRef(null);
  const [lng, setLng] = React.useState(77.7013);
  const [lat, setLat] = React.useState(12.9109);
  const [zoom, setZoom] = React.useState(5);

  /* Clean Map Function */

  const cleanMap = () => {
    /* Remove Heavie */

    if (map.current.getLayer("heavie-layer")) {
      map.current.removeLayer("heavie-layer");
    }
    if (map.current.getSource("heavie")) {
      map.current.removeSource("heavie");
    }

    /* Remove Schools */

    if (map.current.getLayer("schools-layer")) {
      map.current.removeLayer("schools-layer");
    }
    if (map.current.getSource("schools")) {
      map.current.removeSource("schools");
    }

    /* Remove Malls */

    if (map.current.getLayer("malls-layer")) {
      map.current.removeLayer("malls-layer");
    }
    if (map.current.getSource("malls")) {
      map.current.removeSource("malls");
    }

    /* Remove Hospitals */

    if (map.current.getLayer("hospitals-layer")) {
      map.current.removeLayer("hospitals-layer");
    }
    if (map.current.getSource("hospitals")) {
      map.current.removeSource("hospitals");
    }

    /* Remove Others */

    if (map.current.getLayer("others-layer")) {
      map.current.removeLayer("others-layer");
    }
    if (map.current.getSource("others")) {
      map.current.removeSource("others");
    }
  };

  /* Add Heavie Function */

  const addHeavie = () => {
    map.current.addSource("heavie", {
      type: "geojson",
      data: "/geodata/heavie.geojson",
    });
    map.current.addLayer({
      id: "heavie-layer",
      type: "symbol",
      source: "heavie",
      layout: {
        "icon-image": "heavie",
        "icon-size": 0.5,
        "text-field": ["format", "\n\n\n", ["get", "Name"], { "font-scale": 0.75 }],
      },
    });
  };

  /* Remove Heavie Function */

  // const removeHeavie = () => {
  //   if (map.current.getLayer("heavie-layer")) {
  //     map.current.removeLayer("heavie-layer");
  //   }
  //   if (map.current.getSource("heavie")) {
  //     map.current.removeSource("heavie");
  //   }
  // };

  /* Add Schools Function */

  const addSchools = () => {
    map.current.addSource("schools", {
      type: "geojson",
      data: "/geodata/vicinity-schools.geojson",
    });
    map.current.addLayer({
      id: "schools-layer",
      type: "symbol",
      source: "schools",
      layout: {
        "icon-image": "university",
        "icon-size": 0.5,
        "text-field": ["format", "\n\n\n", ["get", "Name"], { "font-scale": 0.75 }],
      },
    });
  };

  /* Remove Schools Function */

  // const removeSchools = () => {
  //   if (map.current.getLayer("schools-layer")) {
  //     map.current.removeLayer("schools-layer");
  //   }
  //   if (map.current.getSource("schools")) {
  //     map.current.removeSource("schools");
  //   }
  // };

  /* Add Malls Function */

  // const addMalls = () => {
  //   map.current.addSource("malls", {
  //     type: "geojson",
  //     data: "/geodata/vicinity-malls.geojson",
  //   });
  //   map.current.addLayer({
  //     id: "malls-layer",
  //     type: "symbol",
  //     source: "malls",
  //     layout: {
  //       "icon-image": "mall",
  //       "icon-size": 0.5,
  //       "text-field": [
  //         "format",
  //         "\n\n\n",
  //         ["get", "Name"],
  //         { "font-scale": 0.75 },
  //       ],
  //     },
  //   });
  // };

  /* Remove Malls Function */

  // const removeMalls = () => {
  //   if (map.current.getLayer("malls-layer")) {
  //     map.current.removeLayer("malls-layer");
  //   }
  //   if (map.current.getSource("malls")) {
  //     map.current.removeSource("malls");
  //   }
  // };

  /* Add Hospitals Function */

  // const addHospitals = () => {
  //   map.current.addSource("hospitals", {
  //     type: "geojson",
  //     data: "/geodata/vicinity-hospitals.geojson",
  //   });
  //   map.current.addLayer({
  //     id: "hospitals-layer",
  //     type: "symbol",
  //     source: "hospitals",
  //     layout: {
  //       "icon-image": "health",
  //       "icon-size": 0.5,
  //       "text-field": [
  //         "format",
  //         "\n\n\n",
  //         ["get", "Name"],
  //         { "font-scale": 0.75 },
  //       ],
  //     },
  //   });
  // };

  /* Remove Hospitals Function */

  // const removeHospitals = () => {
  //   if (map.current.getLayer("hospitals-layer")) {
  //     map.current.removeLayer("hospitals-layer");
  //   }
  //   if (map.current.getSource("hospitals")) {
  //     map.current.removeSource("hospitals");
  //   }
  // };

  /* Add Others Function */

  // const addOthers = () => {
  //   map.current.addSource("others", {
  //     type: "geojson",
  //     data: "/geodata/vicinity-others.geojson",
  //   });
  //   map.current.addLayer({
  //     id: "others-layer",
  //     type: "symbol",
  //     source: "others",
  //     layout: {
  //       "icon-image": "other",
  //       "icon-size": 0.5,
  //       "text-field": [
  //         "format",
  //         "\n\n\n",
  //         ["get", "Name"],
  //         { "font-scale": 0.75 },
  //       ],
  //     },
  //   });
  // };

  /* Remove Others Function */

  // const removeOthers = () => {
  //   if (map.current.getLayer("others-layer")) {
  //     map.current.removeLayer("others-layer");
  //   }
  //   if (map.current.getSource("others")) {
  //     map.current.removeSource("others");
  //   }
  // };

  /* Initialize a new map */

  React.useEffect(() => {
    let io = false;
    let once = false;
    if (map.current) {
      return;
    }

    map.current = new mapboxgl.Map({
      container: mapContainer.current,
      style: process.env.MAPBOX_STYLE_URI,
      center: [lng, lat],
      zoom: zoom,
      pitch: 0,
      bearing: 135,
    });

    map.current.on("load", () => {
      // Disable single-finger touch gestures and enable two-finger gestures
      map.current.touchZoomRotate.disableRotation();
      map.current.touchZoomRotate.enable({ around: "center", touchZoom: true });
      /* Track mapView */
      new IntersectionObserver(
        () => {
          if (io && !once) {
            map.current.flyTo(heavieMapView);
            once = true;
          } else {
            io = true;
          }
        },
        {
          threshold: 1,
        },
      ).observe(mapContainer.current);
      setMapLoaded(true);
      setFlightSpeed(0.75);
      // map.current.loadImage(
      //   "/images/icons/vicinity/png/university.png",
      //   (error, image) => {
      //     if (error) throw error;
      //     map.current.addImage("university", image);
      //   }
      // );
      // map.current.loadImage(
      //   "/images/icons/vicinity/png/health.png",
      //   (error, image) => {
      //     if (error) throw error;
      //     map.current.addImage("health", image);
      //   }
      // );
      // map.current.loadImage(
      //   "/images/icons/vicinity/png/mall.png",
      //   (error, image) => {
      //     if (error) throw error;
      //     map.current.addImage("mall", image);
      //   }
      // );
      // map.current.loadImage(
      //   "/images/icons/vicinity/png/other.png",
      //   (error, image) => {
      //     if (error) throw error;
      //     map.current.addImage("other", image);
      //   }
      // );
      addHeavie();
      addSchools();
      const popup = new mapboxgl.Popup({
        className: classes.popupStyles,
      });
      for (let i = 0; i < layerIterator.length; i++) {
        map.current.on("click", layerIterator[i], (e) => {
          map.current.getCanvas().style.cursor = "pointer";
          const coordinates = e.features[0].geometry.coordinates.slice();
          const description = e.features[0].properties.description;
          const name = e.features[0].properties.Name;
          const logoUrl = e.features[0].properties.logoUrl;
          while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
            coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
          }
          popup
            .setLngLat(coordinates)
            .setHTML(
              `

        <center><img src="${logoUrl}" width="${name === "Heavie Eden by Sentient" ? "220" : "72"}" height="${
          name === "Heavie Eden by Sentient" ? "135" : "72"
        }" loading="lazy" title="${name}" referrerPolicy="no-referrer"  alt="${AppConfig.imageAltText}" /></center>
        <b>${name}</b>
        <hr/>
        <p>${description}</p>

        `,
            )
            .addTo(map.current);
        });
        map.current.on("mouseenter", layerIterator[i], () => {
          map.current.getCanvas().style.cursor = "pointer";
        });
        map.current.on("mouseleave", layerIterator[i], () => {
          map.current.getCanvas().style.cursor = "";
        });
      }
    });

    map.current.on("move", () => {
      setLng(map.current.getCenter().lng.toFixed(4));
      setLat(map.current.getCenter().lat.toFixed(4));
      setZoom(map.current.getZoom().toFixed(2));
    });
  }, []);

  /* Function to control map on vicinity tab change */

  // const handleTabChange = (vicinityIndex) => {
  //   if (mapLoaded) {
  //     cleanMap();
  //     switch (vicinityIndex) {
  //       case 0:
  //         addHeavie();
  //         addSchools();
  //         map.current.flyTo(schoolMapView);
  //         break;
  //       case 1:
  //         addHeavie();
  //         addMalls();
  //         map.current.flyTo(mallMapView);
  //         break;
  //       case 2:
  //         addHeavie();
  //         addHospitals();
  //         map.current.flyTo(hospitalMapView);
  //         break;
  //       case 3:
  //         addHeavie();
  //         addOthers();
  //         map.current.flyTo(otherMapView);
  //         break;
  //       default:
  //         addHeavie();
  //         addSchools();
  //         // map.current.flyTo(heavieMapView);
  //         map.current.flyTo(schoolMapView);
  //         break;
  //     }
  //   }
  // };

  const handleTabChange = (vicinityIndex) => {
    if (mapLoaded) {
      cleanMap(); // Clear existing layers and sources

      const vicinityData = [
        {
          view: schoolMapView,
          data: "/geodata/vicinity-schools.geojson",
          icon: "university",
          layerId: "schools-layer",
        },
        { view: mallMapView, data: "/geodata/vicinity-malls.geojson", icon: "mall", layerId: "malls-layer" },
        {
          view: hospitalMapView,
          data: "/geodata/vicinity-hospitals.geojson",
          icon: "health",
          layerId: "hospitals-layer",
        },
        { view: otherMapView, data: "/geodata/vicinity-others.geojson", icon: "other", layerId: "others-layer" },
      ];

      // Add Heavie layer for all tabs
      addHeavie();

      if (vicinityIndex >= 0 && vicinityIndex < vicinityData.length) {
        const { view, data, icon, layerId } = vicinityData[vicinityIndex];
        console.log("layerId", layerId);
        // Fetch and add markers for the selected tab
        fetch(data)
          .then((response) => response.json())
          .then((geojsonData) => {
            const addMarkers = (data, icon, layerId) => {
              map.current.addSource(layerId, {
                type: "geojson",
                data: data,
              });
              if (map.current.getSource(layerId)) {
                map.current.removeLayer(layerId); // Remove the existing layer
                map.current.removeSource(layerId); // Remove the existing source
              }

              map.current.addLayer({
                id: layerId,
                type: "symbol",
                source: layerId,
                layout: {
                  "icon-image": icon,
                  "icon-size": 0.5,
                  "text-field": ["format", "\n\n\n", ["get", "Name"], { "font-scale": 0.75 }],
                },
              });

              // Add markers with popups
              data.features.forEach((feature) => {
                const { coordinates } = feature.geometry;
                const { Name, description, googleMapsLink } = feature.properties;

                new mapboxgl.Marker()
                  .setLngLat(coordinates)
                  .setPopup(
                    new mapboxgl.Popup({ offset: 25 }).setHTML(
                      `
                    <h3>${Name}</h3>
                    <p>${description}</p>
                    <a href="${googleMapsLink}" target="_blank" rel="noopener noreferrer">
                      View on Larger Map
                    </a>
                    `,
                    ),
                  )
                  .addTo(map.current);
              });
            };

            addMarkers(geojsonData, icon, layerId);
          });

        // Fly to the selected view
        map.current.flyTo(view);
      } else {
        // Default case: Fly to Heavie view
        map.current.flyTo(heavieMapView);
      }
    }
  };

  //   const addMarkers = (data, icon, layerId) => {
  //     if (map.current.getSource(layerId)) {
  //     map.current.removeLayer(layerId); // Remove the existing layer
  //     map.current.removeSource(layerId); // Remove the existing source
  //   }
  //   map.current.addSource(layerId, {
  //     type: "geojson",
  //     data: data,
  //   });

  //   map.current.addLayer({
  //     id: layerId,
  //     type: "symbol",
  //     source: layerId,
  //     layout: {
  //       "icon-image": icon,
  //       "icon-size": 0.5,
  //       "text-field": [
  //         "format",
  //         "\n\n\n",
  //         ["get", "Name"],
  //         { "font-scale": 0.75 },
  //       ],
  //     },
  //   });

  //   // Add markers with popups
  //   data.features.forEach((feature) => {
  //     const { coordinates } = feature.geometry;
  //     const { Name, description, googleMapsLink } = feature.properties;

  //     new mapboxgl.Marker()
  //       .setLngLat(coordinates)
  //       .setPopup(
  //         new mapboxgl.Popup({ offset: 25 }).setHTML(
  //           `
  //           <h3>${Name}</h3>
  //           <p>${description}</p>
  //           <a href="${googleMapsLink}" target="_blank" rel="noopener noreferrer">
  //             View on Larger Map
  //           </a>
  //           `
  //         )
  //       )
  //       .addTo(map.current);
  //   });
  // };

  // React.useEffect(() => {
  //   console.log(lat, lng, zoom);
  // }, [lat, lng, zoom]);

  return (
    <React.Fragment>
      <div className={classes.mainContainer}>
        <div className={classes.sectionContainer}>
          <div className={classes.mapBox}>
            <div
              ref={mapContainer}
              className={classes.illustrationSizer}
            >
              <Fab
                size="small"
                color="primary"
                className={classes.resetMapButton}
                onClick={() => {
                  map.current.flyTo(heavieMapView);
                }}
              >
                <SvgIcon
                  component={Heavie}
                  viewBox={"0 0 " + Heavie().props.width + " " + Heavie().props.height}
                />
              </Fab>
              <div style={{ position: "absolute", bottom: "1rem", right: "1rem", zIndex: 3 }}>
                <a
                  href="https://maps.app.goo.gl/rBERQj12aU2j7bJV7"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    textDecoration: "none",
                    backgroundColor: "#FFFFFF",
                    color: "#000000",
                    padding: "0.5rem 1rem",
                    borderRadius: "4px",
                    boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                    fontSize: "0.875rem",
                    fontWeight: "bold",
                  }}
                >
                  View on Larger Maps
                </a>
              </div>
            </div>
          </div>
          <div className={classes.text}>
            <Typography
              variant="h6"
              component="span"
              className={classes.subHeading}
            >
              Connectivity and Appreciation
            </Typography>
            <Typography
              variant="h6"
              component="span"
              className={classes.bodyText}
            >
              Spend more time doing what you love, rather than being in traffic. With the rapidly growing infrastructure
              and the strategic location of Heavie Eden, commute via Sarjapur Main Road decreases travel time and
              provides unmatched connectivity to Bengaluru.
            </Typography>

            <div className={classes.viv}>
              <VicinityTab
                onChange={(index) => {
                  handleTabChange(index);
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default LocationSub;
